// MiloStartScreen.jsx
import React from "react";
import styles from "../styles/MiloStartScreen.module.css";

const MiloStartScreen = ({ setStep }) => (
  <div className={styles["miloStartScreen"]}>
    <div className={styles["miloStartCard"]}>
      <p className={styles["miloTagline"]}>
		Say Goodbye to Waiting—Lease Instantly with MILO.
	  </p>
      <h1 className={styles["miloTitle"]}>The MILO Experience</h1>
      <p className={styles["miloSubtitle"]}>Fast, simple, and instant approvals.</p>
      <button className={styles["startDemoButton"]} onClick={() => setStep(1)}>
        See How MILO Works in 60 Seconds ✅
      </button>
    </div>
  </div>
);

export default MiloStartScreen;


